
import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslationService } from '../../../services/translation/translation.service';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor(public translationService: TranslationService) {
    super();
    this.translationService.loadTranslations('fr').then(x => {
      this.getAndInitTranslations();
    });
  }

  getAndInitTranslations() {
    this.itemsPerPageLabel = this.translationService.translate('Items per page:');
    this.nextPageLabel = this.translationService.translate('Next page');
    this.previousPageLabel = this.translationService.translate('Previous page');
    this.lastPageLabel = this.translationService.translate('Last page');
    this.firstPageLabel = this.translationService.translate('First page');
    this.changes.next();

  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 / ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} / ${length}`;
  }
}
